export const ALL_CATEGORIES_REQUEST = "ALL_CATEGORIES_REQUEST";
export const ALL_CATEGORIES_SUCCESS = "ALL_CATEGORIES_SUCCESS";
export const ALL_CATEGORIES_FAIL = "ALL_CATEGORIES_FAIL";

export const NEW_CATEGORY_REQUEST = "NEW_CATEGORY_REQUEST";
export const NEW_CATEGORY_SUCCESS = "NEW_CATEGORY_SUCCESS";
export const NEW_CATEGORY_RESET = "NEW_CATEGORY_RESET";
export const NEW_CATEGORY_FAIL = "NEW_CATEGORY_FAIL";

export const DELETE_CATEGORY_REQUEST = "DELETE_CATEGORY_REQUEST";
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_RESET = "DELETE_CATEGORY_RESET";
export const DELETE_CATEGORY_FAIL = "DELETE_CATEGORY_FAIL";

export const DELETE_CATEGORIES_REQUEST = "DELETE_CATEGORIES_REQUEST";
export const DELETE_CATEGORIES_SUCCESS = "DELETE_CATEGORIES_SUCCESS";
export const DELETE_CATEGORIES_RESET = "DELETE_CATEGORIES_RESET";
export const DELETE_CATEGORIES_FAIL = "DELETE_CATEGORIES_FAIL";

export const UPDATE_CATEGORY_REQUEST = "UPDATE_CATEGORY_REQUEST";
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_RESET = "UPDATE_CATEGORY_RESET";
export const UPDATE_CATEGORY_FAIL = "UPDATE_CATEGORY_FAIL";

export const CATEGORY_DETAILS_REQUEST = "CATEGORY_DETAILS_REQUEST";
export const CATEGORY_DETAILS_SUCCESS = "CATEGORY_DETAILS_SUCCESS";
export const CATEGORY_DETAILS_FAIL = "CATEGORY_DETAILS_FAIL";

export const REMOVE_CATEGORY_DETAILS = "REMOVE_CATEGORY_DETAILS";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
